/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetMediaExportJobsDownloadUrlQueryResponse, GetMediaExportJobsDownloadUrlPathParams, GetMediaExportJobsDownloadUrl404 } from "../models/GetMediaExportJobsDownloadUrl";

export function getGetMediaExportJobsDownloadUrlUrl(id: GetMediaExportJobsDownloadUrlPathParams["id"]) {
  const res = { method: 'GET', url: `/export-jobs/${id}/download-url` as const }
  return res
}

/**
 * @description Returns a signed URL to download the exported file for a completed job.
 * @summary Get signed download URL
 * {@link /export-jobs/:id/download-url}
 */
export async function getMediaExportJobsDownloadUrl(id: GetMediaExportJobsDownloadUrlPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetMediaExportJobsDownloadUrlQueryResponse, ResponseErrorConfig<GetMediaExportJobsDownloadUrl404>, unknown>({ method : "GET", url : getGetMediaExportJobsDownloadUrlUrl(id).url.toString(), ... requestConfig })
  return res.data
}